<template>
  <div class="my-card bg-lightGray d-flex flex-column justify-space-between pa-lg-7">
    <router-link :to="{name: 'PerfilPsicologoPublico', params: {id: psy.slug}}" class="text-center">
      <v-row class="align-start justify-space-between ma-0">
        <v-col class="col-12 pl-lg-0 col-lg-auto text-center pb-0">
          <v-avatar size="120">
            <v-img v-if="psy.photo != ''" :src="psy.photo"></v-img>
            <v-img v-if="psy.photo == ''" :src="require('../assets/no-image.png')"></v-img>
          </v-avatar>
          <div class="text-center mt-1">
            <v-chip v-if="psy.has_bookable_vacancies" small color="success" text-color="white">Horário Disponível</v-chip>
            <v-chip v-else small color="gray" text-color="white">Sem Horário</v-chip>
          </div>
        </v-col>
        <v-col class="col-12 col-lg-7 pt-0 text-center">
          <p class="text--my-card text-center text-truncate">
            {{ psy.name }}
            <v-icon v-if="psy.is_chief_therapist" dark class="primary--text icon-psy-name" size="32">bookmark</v-icon>
          </p>
          <p v-if="psy.language === 'pt'" class="text-center ma-0 color-gray f-990">OPP: {{ psy.opp }}</p>
          <p v-else class="text-center ma-0 mt-1 color-gray f-990">CRP: {{ psy.crp }}</p>
          <div class="text-center">
            <v-rating
              readonly
              :value="psy.average"
              color="amber"
              background-color="gray lighten-1">
            </v-rating>
          </div>
          <div class="text-left">
            <span
              v-for="(speciality, index) in psy.specialities.slice(0, 3)"
              :key="index"
              class="specialities color-green f-880 mt-3 mr-2"
              style="display: inline-block"
            >{{speciality}}</span>

            <span
              v-if="psy.specialities.length > 3"
              style="display: inline-block;"
              class="specialities color-green f-880 mt-3 mr-2"
            >E mais...</span>
          </div>
        </v-col>
      </v-row>
    </router-link>

    <div class="text-left">
      <div class="d-flex align-center justify-start mt-2" style="margin-left: -3px;">
        <v-icon dark class="primary--text text--darken-1" size="34">flag</v-icon>
        <p class="ml-3 text-center ma-0 color-gray">{{ psy.country }}</p>
      </div>
      <div class="d-flex align-center justify-start mt-3">
        <img :src="require('../assets/icone-money.svg')" style="width: 28px;" />
        <!-- <v-icon dark class="primary--text text--darken-1" size="32">attach_money</v-icon> -->
        <p
          class="ml-3 text-center ma-0 color-gray"
          v-if="psy.appointment_br_value != '0.00' && psy.language === 'pt-BR'"
        >
          R$ {{ psy.appointment_br_value }}
        </p>
        <p
          class="ml-3 text-center ma-0 color-gray"
          v-if="psy.appointment_pt_value != '0.00' && psy.language === 'pt'"
        >€ {{psy.appointment_pt_value}}</p>
      </div>
      <div class="d-flex align-center justify-start mt-3">
        <v-icon dark class="primary--text text--darken-1" size="30">chat_bubble</v-icon>
        <p
          style="margin-bottom: 8px !important;"
          class="ml-3 text-center ma-0 color-gray"
          v-if="psy.language === 'pt-br'"
        >Português Brasileiro</p>
        <p
          style="margin-bottom: 8px !important;"
          class="ml-3 text-center ma-0 color-gray"
          v-else
        >Português</p>
      </div>

      <div class="d-flex align-center justify-start mt-3">
        <p class="text-left ma-0 color-gray lato-light">{{psy.biography | truncate(130, '...')}}</p>
      </div>
    </div>

    <div class="text-center mt-3" v-if="category != 'psychologist'">
      <v-btn class="br-10" color="secondary" :to="{ name: 'PerfilPsicologoPublico', params: { id: psy.slug } }">
        AGENDAR CONSULTA
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CardPsyPublico',
  data: () => ({
    category: '',
  }),
  props: {
    psy: Object,
    language: null,
  },

  filters: {
    // eslint-disable-next-line consistent-return
    truncate(text, length, suffix) {
      if (text != null) {
        if (text.length > length) {
          return text.substring(0, length) + suffix;
        // eslint-disable-next-line no-else-return
        } else {
          return text;
        }
      }
    },
  },
  async mounted() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      this.category = localStorage.getItem('user-category');
    },
  }
};
</script>

<style lang="scss" scoped>
.specialities {
  padding: 3px 15px;
  border: 1px solid green;
  border-radius: 25px;
}

.my-card {
  padding: 10px;
  border-radius: 8px;
  min-height: 500px;

  a {
    text-decoration: none;
  }
}
.text--my-card {
  margin: 10px 0;
  padding: 8px 25px;
  border-radius: 20px;
  background-color: var(--v-white-base);
  position: relative;
  .icon-psy-name {
    position: absolute;
    top: -5px;
    right: 11px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .my-card {
    min-height: 590px;
  }
}
</style>
